import Animator from './Animator';
import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.binder(Hooks.AnimatorRoot, Animator);
